;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.5";import {
  initBrowserInstrumentation,
  isProductionEnv,
  onRouterTransitionStart,
} from '@netpurpose/utils'
import { sentryConfig } from './sentryShared.config'

initBrowserInstrumentation({
  sentryConfig,
  isProduction: isProductionEnv(),
  posthogKey: process.env['NEXT_PUBLIC_POSTHOG_KEY'] || '',
})

export { onRouterTransitionStart }
